<template>
  <div>
    <GlobalWebsiteStylesAndScripts />
    <LazyLoadInit />

    <ContentBuilderCustomScripts />
    <LightBoxInit />

    <CollectionPagesScriptsAndStyles v-if="state.isCollectionPagesVisible" />
    <SearchPageScriptsAndStyles v-if="state.isSearchPageVisible" />

    <TutcoImmediateAssistanceModal />
    <MailChimpSignUpFormModal />
    <ContinueModal />
    <InfoModal />
    <ConfirmationModal />
    <SearchImpersonateModal v-if="state.canImpersonate" />

    <NotificationsComponent v-if="notificationsStore.notifications.length > 0" />
  </div>
</template>

<script setup lang="ts">
import { defineAsyncComponent, onMounted, reactive } from 'vue';
import GlobalPreloaderHelper from '@/helpers/global/globalPreloader.helper';
import useNotificationsStore from '@/store/notifications';
import useUserInfoStore from '@/store/userInfo';
import DropdownsHelper from '@/helpers/global/dropdowns.helper';

// Synchronous imports for always-used components (bundled in main chunk)
import GlobalWebsiteStylesAndScripts from '@/components/website/global/GlobalWebsiteStylesAndScripts.vue';
import LazyLoadInit from '@/components/global/LazyLoadInit.vue';
import TutcoImmediateAssistanceModal from '@/components/website/modals/TutcoImmediateAssistanceModal.vue';
import MailChimpSignUpFormModal from '@/components/website/modals/MailChimpSignUpFormModal.vue';
import ContentBuilderCustomScripts from '@/components/website/content-builder/ContentBuilderCustomScripts.vue';
import LightBoxInit from '@/components/website/content-builder/LightBoxInit.vue';
import NotificationsComponent from '@/components/global/notifications/NotificationsComponent.vue';
import ContinueModal from '@/components/website/modals/ContinueModal.vue';
import InfoModal from '@/components/website/modals/InfoModal.vue';
import ConfirmationModal from '@/components/website/modals/ConfirmationModal.vue';
import SearchImpersonateModal from '@/components/website/modals/SearchImpersonateModal.vue';

// Async imports for conditionally-used components (code splitting)
const CollectionPagesScriptsAndStyles = defineAsyncComponent(
  () => import('@/components/website/collection-pages/CollectionPagesScriptsAndStyles.vue')
);
const SearchPageScriptsAndStyles = defineAsyncComponent(() => import('@/components/website/search-page/SearchPageScriptsAndStyles.vue'));

const notificationsStore = useNotificationsStore();
const userInfoStore = useUserInfoStore();

const state = reactive({
  isContentBuilderVisible: false,
  isCollectionPagesVisible: false,
  isSearchPageVisible: false,
  canImpersonate: false,
});

onMounted(() => {
  GlobalPreloaderHelper.init();
  DropdownsHelper.init();

  state.isContentBuilderVisible = document.querySelector('.content-builder-area') !== null;
  state.isCollectionPagesVisible = Boolean(IS_COLLECTION_PAGE_VISIBLE);
  state.isSearchPageVisible = Boolean(IS_SEARCH_PAGE_VISIBLE);
  state.canImpersonate = typeof CAN_IMPERSONATE !== 'undefined' && Boolean(CAN_IMPERSONATE);
});
</script>
